import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { GET_SHIPMENT_TYPES } from "@/constants/Query";
import { IShipmentType } from "@/types/apiResponse.types";

export const useGetShipmentTypesRequest = () => {
  return useQuery<{
    data: {
      data: IShipmentType[];
    };
  }>({
    queryKey: [GET_SHIPMENT_TYPES],
    queryFn: () => apiRequest(GET_SHIPMENT_TYPES, "get"),
  });
};
